import { render, staticRenderFns } from "./TermsOfUseFooter.vue?vue&type=template&id=c3cd9f50"
import script from "./TermsOfUseFooter.vue?vue&type=script&lang=js"
export * from "./TermsOfUseFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports